<template lang="html">
  <b-container
    v-if="
      $store.state.authorized &&
        !$store.state.user.emailVerified &&
        !lastFewHoursSignUp
    "
    class="mt-3"
  >
    <b-row>
      <b-col md="12">
        <b-alert v-model="showWarning" dismissible variant="warning" show>
          Welcome! Please check your email to verify your email address.
          <b-btn
            v-if="!recentSignup"
            size="sm"
            variant="primary"
            class="ml-3"
            @click="
              $store.dispatch('sendEmailVerification');
              showWarning = false;
            "
          >
            Re-send verification email
          </b-btn>
        </b-alert>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { toDate, differenceInDays, differenceInMinutes } from "date-fns";
export default {
  name: "Announcement",
  data() {
    return {
      showWarning: true
    };
  },
  computed: {
    recentSignup() {
      if (!this.$store.state.user_doc.created_at) {
        return true;
      }
      var now = new Date().getTime();
      var diff = differenceInDays(
        now,
        toDate(this.$store.state.user_doc.created_at)
      );
      return diff < 3;
    },
    lastFewHoursSignUp() {
      // Don't show email verification warning within the first 4 hours.
      if (!this.$store.state.user_doc.created_at) {
        return true;
      }
      var now = new Date().getTime();
      var diff = differenceInMinutes(
        now,
        toDate(this.$store.state.user_doc.created_at)
      );
      return diff < 60 * 4;
    }
  }
};
</script>

<style lang="css" scoped></style>
